import { Action, createReducer, on } from '@ngrx/store';
import { LoadStatus } from '@capital-access/common/utils';
import { loadAccountUsersFail, loadAccountUsersSuccess } from './account-users.actions';
import { loadAccountUsersStart } from './account-users.actions.internal';
import { AccountUsersState } from './account-users.state';

export const getInitialState = (): AccountUsersState => ({
  users: [],
  loadStatus: LoadStatus.Pristine,
  error: null
});

export const reducer = createReducer(
  getInitialState(),
  on(loadAccountUsersStart, state => ({
    ...state,
    loadStatus: LoadStatus.Loading
  })),

  on(loadAccountUsersSuccess, (state, { users }) => ({
    ...state,
    users,
    loadStatus: LoadStatus.Loaded
  })),

  on(loadAccountUsersFail, (state, { error }) => ({
    ...state,
    loadStatus: LoadStatus.Failed,
    error
  }))
);

export function accountUsersReducer(state: AccountUsersState | undefined, action: Action) {
  return reducer(state, action);
}
